function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import axios from 'axios';
import { Formik, Field, ErrorMessage } from 'formik';
import Select from 'react-select';
import PropTypes from 'prop-types';
import defaultPropTypes from '@demant/locations-spot/lib/js/utils/prop-types';

var SelectField = function SelectField(_ref) {
  var options = _ref.options,
      field = _ref.field,
      form = _ref.form;
  var customStyles = {
    singleValue: function singleValue(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        overflow: 'visible'
      });
    },
    control: function control(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        borderColor: '#B7B3AC',
        '&:hover': {
          borderColor: '#c6168d'
        },
        boxShadow: 'none',
        marginBottom: '0.5rem',
        borderRadius: state.menuIsOpen ? '3px 3px 0 0' : '3px',
        padding: '0.3rem',
        fontSize: '1rem'
      });
    },
    option: function option(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        // eslint-disable-next-line no-nested-ternary
        backgroundColor: state.isSelected ? '#6B6867' : state.isFocused ? '#F7F6F4' : 'none',
        // eslint-disable-next-line no-nested-ternary
        color: state.isSelected ? 'white' : 'inherit',
        padding: '1rem',
        '&:not(:last-child)': {
          borderBottom: '1px solid #B7B3AC'
        },
        '&:last-child': {
          borderRadius: '0 0 3px 3px'
        }
      });
    },
    dropdownIndicator: function dropdownIndicator(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        color: '#c6168d',
        padding: '0.4rem 0.4rem 0.4rem 0.6rem'
      });
    },
    indicatorSeparator: function indicatorSeparator(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        backgroundColor: '#D7D3CC',
        marginBottom: '-0.3rem',
        marginTop: '-0.3rem'
      });
    },
    menu: function menu(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        marginTop: 0,
        border: '1px solid #B7B3AC',
        borderTop: 0,
        boxShadow: 'none',
        borderRadius: '0 0 3px 3px',
        boxSizing: 'border-box'
      });
    },
    menuList: function menuList(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        padding: 0,
        margin: 0
      });
    }
  };
  return /*#__PURE__*/React.createElement(Select, {
    options: options,
    value: options ? options.find(function (option) {
      return option.value === field.value;
    }) : '',
    placeholder: field.placeholder,
    isClearable: false,
    isSearchable: false,
    onChange: function onChange(option) {
      return form.setFieldValue(field.name, option.value);
    },
    className: "location-detail-form__input location-detail-form__input--select",
    styles: customStyles
  });
};

SelectField.propTypes = {
  options: PropTypes.arrayOf(defaultPropTypes.formSelectOption).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  field: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.any.isRequired
};

var CheckBox = function CheckBox(props) {
  return /*#__PURE__*/React.createElement(Field, {
    name: props.name
  }, function (_ref2) {
    var field = _ref2.field,
        form = _ref2.form;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({
      type: "checkbox"
    }, props, {
      /* Because we get a string and not a boolean from the backend,
      we convert it to a boolean. If there is ANYTHING in the string
      (even 'false') it will resolve to true. So value should be empty
      for false (ie. checkbox not checked initially) */
      checked: !!field.value,
      onChange: function onChange() {
        form.setFieldValue(field.name, !field.value);
      }
    })), /*#__PURE__*/React.createElement("label", {
      dangerouslySetInnerHTML: {
        __html: props.label
      },
      htmlFor: props.id
    }));
  });
};

CheckBox.propTypes = {
  name: defaultPropTypes.string.isRequired,
  label: defaultPropTypes.string.isRequired,
  id: defaultPropTypes.string.isRequired
};

var OticonLocationDetailForm = function OticonLocationDetailForm(props) {
  var initialValues = props.Fields.reduce(function (acc, field) {
    acc[field.Name] = field.Value;
    return acc;
  }, {});

  var validate = function validate(values) {
    var errors = {};
    var keys = Object.keys(values);
    keys.forEach(function (key) {
      var _props$Fields$find = props.Fields.find(function (field) {
        return field.Name === key;
      }),
          required = _props$Fields$find.Required,
          pattern = _props$Fields$find.Pattern,
          errorMessage = _props$Fields$find.ErrorMessage;

      if (required && !values[key]) {
        errors[key] = errorMessage.Required;
      } else if (pattern) {
        var regex = new RegExp(pattern);

        if (!regex.test(values[key])) {
          errors[key] = errorMessage.Pattern;
        }
      }
    });
    return errors;
  };

  var handleFocusSingleLine = function handleFocusSingleLine(id) {
    document.getElementById("single-line-label-".concat(id)).classList.add('location-detail-form__label--focus');
  };

  var onSubmit = function onSubmit(values, _ref3) {
    var setSubmitting = _ref3.setSubmitting;
    // Create the payload
    var payload = {};
    payload.fields = Object.keys(values).map(function (key) {
      return {
        name: key,
        value: values[key]
      };
    });
    payload.id = props.configurationId;
    payload.clinic = props.clinicDetails; // call onFormWillSubmit callback with payload

    props.onFormWillSubmit(payload); // create the endpoint url

    var endPoint = "".concat(props.SubmitEndPoint);
    axios.post(endPoint, payload).then(function (response) {
      // Endpoint always responds with status code 200, so we have to
      // check for errors by checking that the `ErrorMessages` array in the
      // response is empty
      if (response.data.ErrorMessages.length > 0) {
        return props.onFormSubmitError(response.data.ErrorMessages[0].Value);
      } // call submitSuccess callback on props


      return props.onFormSubmitSuccess();
    }).catch(function (error) {
      props.onFormSubmitError(error);
    }).finally(function () {
      return setSubmitting(false);
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "location-detail-form"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "location-detail-form__heading"
  }, props.FormTitle), /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit,
    render: function render(formikProps) {
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: formikProps.handleSubmit,
        className: "location-detail-form__form"
      }, props.Fields.map(function (field) {
        if (field.Type === 'select') {
          // convert keys to lowercase
          var options = field.Options.map(function (option) {
            return {
              value: option.Value,
              label: option.Label
            };
          });
          return /*#__PURE__*/React.createElement("div", {
            key: field.Name,
            className: "location-detail-form__row"
          }, /*#__PURE__*/React.createElement(Field, {
            name: field.Name,
            component: SelectField,
            options: options,
            placeholder: field.Placeholder,
            "aria-labelledby": "label-".concat(field.Name)
          }), /*#__PURE__*/React.createElement("div", {
            className: "location-detail-form__field-info"
          }, field.Label && /*#__PURE__*/React.createElement("div", {
            id: "label-".concat(field.Name)
          }, field.Label)));
        } else if (field.Type === 'checkbox') {
          return /*#__PURE__*/React.createElement("div", {
            key: "key-".concat(field.Name),
            className: "location-detail-form__row"
          }, /*#__PURE__*/React.createElement(CheckBox, {
            name: field.Name,
            checked: field.Value,
            id: "checkbox-".concat(field.Name),
            label: field.Label,
            className: "location-detail-form__input location-detail-form__input--checkbox ".concat(formikProps.errors[field.Name] ? 'location-detail-form__input--checkbox--error' : '')
          }), /*#__PURE__*/React.createElement("div", {
            className: "location-detail-form__field-info"
          }, /*#__PURE__*/React.createElement(ErrorMessage, {
            name: field.Name,
            component: "div",
            className: "location-detail-form__error location-detail-form__error--checkbox"
          })));
        }

        return /*#__PURE__*/React.createElement("div", {
          key: "key-".concat(field.Name),
          className: "location-detail-form__row"
        }, /*#__PURE__*/React.createElement(Field, {
          type: field.Type,
          name: field.Name,
          id: field.Name,
          "aria-labelledby": "single-line-label-".concat(field.Name),
          onFocus: function onFocus() {
            handleFocusSingleLine(field.Name);
          },
          className: "location-detail-form__input location-detail-form__singleline ".concat(formikProps.errors[field.Name] ? 'location-detail-form__singleline--error' : '')
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: field.Name,
          className: "location-detail-form__label",
          id: "single-line-label-".concat(field.Name)
        }, field.Placeholder), /*#__PURE__*/React.createElement("div", {
          className: "location-detail-form__field-info"
        }, field.Label && /*#__PURE__*/React.createElement("div", {
          id: "info-".concat(field.Name)
        }, field.Label), /*#__PURE__*/React.createElement(ErrorMessage, {
          name: field.Name,
          component: "div",
          className: "location-detail-form__error"
        })));
      }), /*#__PURE__*/React.createElement("button", {
        type: "submit",
        className: "location-detail-form__button",
        disabled: formikProps.isSubmitting
      }, props.SubmitLabel));
    }
  }));
};

OticonLocationDetailForm.propTypes = {
  Fields: PropTypes.arrayOf(defaultPropTypes.formField).isRequired,
  FormTitle: PropTypes.string.isRequired,
  SubmitLabel: PropTypes.string.isRequired,
  SubmitEndPoint: PropTypes.string.isRequired,
  configurationId: PropTypes.string.isRequired,
  onFormSubmitSuccess: defaultPropTypes.func,
  onFormSubmitError: defaultPropTypes.func,
  onFormWillSubmit: defaultPropTypes.func,
  clinicDetails: PropTypes.string
};
OticonLocationDetailForm.defaultProps = {
  onFormSubmitSuccess: function onFormSubmitSuccess() {
    return null;
  },
  onFormSubmitError: function onFormSubmitError() {
    return null;
  },
  onFormWillSubmit: function onFormWillSubmit() {
    return null;
  },
  clinicDetails: ''
};
export default OticonLocationDetailForm;